const checkFileType = (accept: string, fileType: string) => {
  const acceptedExtensions = accept.split(',');
  return acceptedExtensions.includes(fileType);
}

export default checkFileType;
